<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'Mobile.Add' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-accordion-group [multiple]="true" [value]="openedAccordions">
    <ion-accordion *ngFor="let toolGroup of cardToolGroups" [value]="toolGroup.name">
      <ion-item slot="header" color="light">
        <ion-label>
          <strong>{{ toolGroup.name | translate }}</strong>
        </ion-label>
      </ion-item>
      <div class="ion-padding" slot="content">
        <ion-list *ngFor="let tool of toolGroup.tools">
          <ion-item>
            <ion-checkbox justify="start" labelPlacement="end" (ionChange)="onToolSelected(tool)" [checked]="tool == selectedTool">
              {{ tool.text | translate }}
            </ion-checkbox>
          </ion-item>
        </ion-list>
      </div>
    </ion-accordion>
  </ion-accordion-group>
</ion-content>

<ion-footer>
  <ion-button (click)="onDismiss()" color="danger">{{ 'Mobile.Cancel' | translate }}</ion-button>
  <ion-button (click)="onSubmit()" color="primary" [disabled]="!cardToolGroups.length || !selectedTool">
    {{ 'Mobile.Confirm' | translate }}
  </ion-button>
</ion-footer>
